<template>
 <div>
<CountryView />
<section class="blogbeep">
   <div class="virg">
   <div class="stroll">
 <div class="dube">  <li class="lucky"><a href="Lokas">
  BUSINESS</a></li></div>   
<h2 class="forbes">Why SwyChr <br>Is the Best<br> App to Send<br> Money from<br> Texas to<br> Over 18<br> African<br>
     Countries</h2>
<p class="sabi"> Are you looking for the easiest way to send money from<br>Texas to anywhere in Africa 
    without long bank queues,<br> high fees, complicated forms, or slow delivery? The<br> SwyChr
     app is changing how people in the United States...</p>

  <div class="face">
<p class="face-son">December 29, 2025 </p> <span class="face-cuzo">
By </span>   <span class="face-cuzo1"><li class="face-jolie"><a href="Amina">Amina</a></li></span>
</div>     
   </div>

 <div class="posture">
<img src="@/assets/images/africamap1.jpg" alt="" width="680px" height="850px">
 </div>  

   </div> 
</section>
 
<section class="blopbeep1">
<div class="virg1">
<div class="seman">
<h2 class="cough">Share:</h2>
<div class="mother-pip115">
<a href=" https://web.facebook.com/swychrglobal" target="_blank"><i class="fab fa-facebook icon-fb"></i> </a>
<a href=" https://www.linkedin.com/authwall?tr" target="_blank"> <i class="fab fa-linkedin icon-fb"></i></a>  
<a href=" https://x.com/swychrglobal?mx=2" target="_blank"><i class="fas fa-times icon-fb"></i></a> 
<a href="https://www.instagram.com/swychrglobal" target="_blank"> <i class="fab fa-instagram icon-fb"></i></a> 
</div> 
</div>

<div class="prisma">
<p class="trima">
Are you looking for the easiest way to send money from Texas to anywhere in Africa without long<br>
bank queues, high fees, complicated forms, or slow delivery? <b class="red">The Swychr App</b> is changing how<br>
people in the United States and across the world send funds to loved ones, pay bills, carry out<br>
businesses, and manage cross-border finances. All of this is possible from your smartphone,<br>
instantly and affordably.
<br>
<br>
It allows you to <b class="red">send money instantly</b>
from your smartphone in Texas to mobile money wallets and<br> bank accounts across the African continent.
<br>
<br>
In this guide, you’ll learn exactly what makes <b class="red">Swychr</b>
the best solution to send money from Texas<br>
to 18+ African countries, which countries are covered, how it works, and why thousands of users<br>
ust it for global remittances.
<br>
<br>
<b>What Is SwyChr?</b>
<br>
<br>
SwyChr is a <b class="red">global money transfer</b>
 and digital wallet app that allows users to send and receive<br>
money internationally, as easy as sending a text message. It’s built for speed, affordability, and <br>
simplicity with no complicated banking paperwork or hidden fees.
<br>
<br>
With SwyChr, you can send money from Texas (or anywhere in the world) straight to bank<br>
accounts, mobile money wallets, and digital wallets.
<br>
<br>
This means you can load your wallet with USD and transfer it directly to a recipient’s local currency<br>
(like Naira, XAF, or Shilling) in seconds.
<br>
<br>
<b>Why Texas residents love using SwyChr</b>
<br>
<br>
The African community in Texas is growing, and so is the need for
<b>reliable remittance tools.</b> 
<br>
SwyChr offers features that traditional banks and many other remittance apps simply don’t.
<br>
Here is why SwyChr is beating the competition:
<br>
<br>
<b>-Fast & Instant Transfers</b>
<br>
<br>
Send money directly from your phone, and transfers happen in minutes, not days.<br>
<br>
<br>
<b>-Low fees and transparent pricing</b>
<br>
<br>
You see exactly what you send, the fees you pay, and what your recipient
<br>
<br>
<b>-No Bank Needed</b>
<br>
<br>
Your recipient doesn’t need a bank account or complicated verification. Just their MOMO account or<br>
<b>SwyChr</b>  on their phone.
<br>
<br>
<b>-Secure & Reliable</b>
<br>
<br>
The app uses bank-grade encryption to ensure your hard-earned money reaches its destination<br>
safely, and can be tracked from start to finish
<br>
<br>
<b>-All-in-One Global Wallet</b>
<br>
<br>
Send money, receive funds, shop online, and manage your <b class="red">virtual cards </b>
 and finances all in one <br>place.
 <br>
 <br>
 <b>-No Physical Agents needed</b>
 <br>
 <br>
 You don’t need to leave your house to send money. Do it from your couch<br>
 <br>
 <br>
  <b>-No Paperwork or In-Person Visits</b>
  <br>
  <br>
  Complete everything on your phone, no bank branches or paperwork.
  <br>
  <br>
   <b>-Built for Global & African Needs</b>
 <br>
 <br>
 SwyChr was designed keeping<b class="red">cross-border transfers</b> 
and mobile money realities in mind<br>
<br>
<br>
 <b>-Supported Countries You Can Send Money To With SwyChr</b>
 <br>
 <br>
 SwyChr stands out because of its massive reach. It enables
 <b>transfers from the U.S.</b> 
 (including <br>Texas) to over 18 African countries, which covers many of the continent’s most important<br>
 remittance corridors.
 <br>
You can send money from Texas directly to:<br>
<br>
<br>
<b>
 Nigeria, Kenya, Cameroon, Senegal, Côte d’Ivoire, Burkina Faso, Togo, Mali, Niger, Guinea,<br>
 Rwanda, Uganda, Tanzania, Benin, Gabon, Congo Brazzaville, Congo (DRC), Zambia   
</b>
<br>
<br>
…and more across the continent
<br>
The list continues to grow as SwyChr expands its global footprint.
<br>
<br>
<b>How SwyChr Works: Steps to Send Money from Texas to Africa</b>
<br>
<br>
Sending money with SwyChr is straightforward, even if you have never used a remittance app<br>
before:
<br>
<br>
<b>-Step 1: Download the SwyChr App</b>
<br>
<br>
Get the app from:
<br>
<br>
Google Play Store: <a href="https://play.google.com/store/apps/details?id=com.innobins.jtqwallet" class="red"> https://swychr.com/download/</a>
<br>
<br>
App Store:  <a href="https://apps.apple.com/ae/app/swychr/id1586029318" class="red">https://swychr.com/download/</a>
<br>
<br>
<b>-Step 2: Create your free account</b>
<br>
<br>
Sign up using your email address. After <b class="red">creation,</b>
you will need to complete a quick identity<br>
verification (KYC) using a valid ID (Passport, ID card, or Driver’s License). Basic verification helps<br>
ensure security, and unlock full transfer capabilities.
<br>
<br>
<b>-Step 3: Add Funds to Your Wallet</b>
<br>
<br>
Load your SwyChr wallet with USD. You can do this easily using your US debit/credit card or other<br>
supported funding methods available in the app.
<br>
<br>
<b>-Step 4: Choose the Recipient Country</b>
<br>
<br>
Select the destination (e.g., Nigeria, Kenya, Cameroon) and enter the recipient’s mobile money or<br>
bank details, and input the amount.
<br>
<br>
<b>-Step 5: Send Instantly</b>
<br>
<br>
Confirm the details and send. The money is usually available in the recipient’s mobile wallet within<br> minutes.
<br>
Most Popular Uses for Sending Money to Africa<br>
<br>
Whether you’re sending funds to support family or doing business internationally, SwyChr makes it <br>
easy:
<br>
<br>
<b>-Family Support</b>
<br>
<br>
Send monthly support to parents or siblings instantly. Help loved ones with living costs, healthcare,<br> or emergencies.
<br>
<br>
<b>-Business Payments</b>
<br>
<br>
Pay suppliers, freelancers, or partners in Africa without foreign bank complications.<br>
<br>
<br>
<b>-Education and tuition</b>
<br>
<br>
Pay tuition directly to schools or guardians in local currency. Also pay for online classes, using the<br>
<b>free virtual card</b>
<br>
<br>
<b>-Mobile Money & Banking</b>
<br>
<br>
Funds can land directly in mobile wallets (like MTN MoMo, Orange money or M-Pesa) or into bank<br>
accounts, depending on the country.
<br>
<br>
<b>Conclusion</b>
<br>
<br>
<b>Sending money from Texas</b>
to over 18 African countries has never been easier than with SwyChr.<br>
From secure, affordable transfers to broad country coverage and instant delivery; SwyChr is the<br>
smart choice for global remittances.
<br>
<br>
Whether you are sending to a city in Nigeria or a village in Zambia,<b class="red"> SwyChr</b>
ensures your money<br>gets there safe, fast, and full.<br>
<br>
Ready to start?<b class="red">Download the SwyChr app</b>
today and make your first transfer from Virginia to home<br>in minutes.
</p>
</div>
</div>
</section>    
 

<section class="blopbeep2">
<div class="virg2">
<div class="skinny">
<img src="@/assets/images/Africa1.jpg" alt="" width="200px" height="200px">
<div class>
<h2 class="post">Previous Post</h2>
<div class="dube1">  <li class="lucky1"><a href="">
  Why SwyChr Is the Best App<br> to Send Money from South<br>Carolina to Over 18 African... </a></li></div>
  </div>
</div>

<div class="skinny1">
<div class>
<h2 class="post1">Next Post</h2>
<div class="dube1">  <li class="lucky2"><a href="">
  Why SwyChr Is the Best App  <br>to Send Money from Virginia <br> to Over 18 African... </a></li></div>
  </div>
  <img src="@/assets/images/Africa1.jpg" alt="" width="200px" height="200px">
</div>
</div>
</section>

<section class="blopbeep3">
  <div class="virg3">
   <h2 class="question">Related Posts</h2>
<div class="bloggers1">
 <div class="jmartins">

<div class="studies">
<img src="@/assets/images/Africa1.jpg" class="villa" alt="" width="230px" height="230px">
<div class="dube">  <li class="lucky7"><a href="Lokas">
  BUSINESS</a></li></div>
<div class="dube9">  <li class="lucky9"><a href="https://swychr.com/why-swychr-is-the-best-app-to-send-money-from-ohio-to-over-18-african-countries/">
  Why SwyChr Is the Best App <br> to Send Money from Virginia <br> to Over 18 African 
  Countries</a></li></div>
<p class="sabath">Are you looking for the easiest way to <br> send money
   from Virginia to anywhere in <br>  Africa without long bank queues, high</p>
 <div class="pius">
<p class="pius-son">December 29, 2025 </p> <span class="pius-cuzo">
By </span>   <span class="pius-cuzo1"><li class="jolie"><a href="Amina">Amina</a></li></span>
</div> 

</div>

<div class="studies">
<img src="@/assets/images/Africa1.jpg" class="villa" alt="" width="230px" height="230px">
<div class="dube">  <li class="lucky7"><a href="Lokas">
  BUSINESS</a></li></div>
<div class="dube9">  <li class="lucky9"><a href="https://swychr.com/why-swychr-is-the-best-app-to-send-money-from-north-carolina-to-over-18-african-countries/">
  Why SwyChr Is the Best App <br> to Send Money from South <br>Carolina to Over 18 African...
<br> </a></li></div>
<p class="sabath2">Are you looking for the easiest way to <br>send money from South Carolina
  to<br>  anywhere in  Africa without long bank...</p>
 <div class="pius2">
<p class="pius-son2">December 29, 2025 </p> <span class="pius-cuzo2">
By </span>   <span class="pius-cuzo3"><li class="jolie2"><a href="Amina">Amina</a></li></span>
</div> 
</div>

<div class="studies">
<img src="@/assets/images/Africa1.jpg" class="villa" alt="" width="230px" height="230px">
<div class="dube">  <li class="lucky7"><a href="Lokas">BUSINESS</a></li></div>
<div class="dube9">  <li class="lucky9"><a href="https://swychr.com/why-swychr-is-the-best-app-to-send-money-from-new-york-to-over-18-african-countries/">
  Why SwyChr Is the Best App <br> to Send Money from  <br>Ohio to Over 18 African
  <br> 
  </a></li></div>
<p class="sabath1">Are you looking for the easiest way to  send money
  from Ohio to anywhere in  Africa without long bank queues, high...</p>
 <div class="face">
<p class="face-son">December 29, 2025 </p> <span class="face-cuzo">
By </span>   <span class="face-cuzo1"><li class="face-jolie"><a href="Amina">Amina</a></li></span>
</div> 
</div>

 </div> 
</div>
   </div>
</section>
  
<section class="blopbeep4">
 <div class="virg4">
   <h2 class="question">Leave a Reply</h2>
   <p class="solod">Your email address will not be published. Required fields are marked *</p>

      <div class="remove">
        <div class="contact-container">
    <form @submit.prevent="handleSubmit" class="contact-form">

      <div class="form-row">
        <div class="form-group">
          <label for="name">Your Name *</label>
          <input 
            type="text" 
            id="name" 
            v-model="formData.name" 
            placeholder="" 
            required 
          />
        </div>

        <div class="form-group">
          <label for="email">Your Email *</label>
          <input 
            type="email" 
            id="email" 
            v-model="formData.email" 
            placeholder="" 
            required 
          />
        </div>
      </div>
  
      <div class="form-group">
        <label for="message">Your Comment *</label>
        <textarea 
          id="message" 
          v-model="formData.message" 
          rows="6" 
          placeholder="" 
          required
        ></textarea>
      </div>
       <p class="solod1">Save my name, email, and website in this browser for the next time I comment.</p>
      <div class="button-container">
        <button type="submit" class="submit-btn">SEND MESSAGE</button>
      </div>
    </form>
  </div>
         </div>
 </div> 
</section>
 
<FooterView />
      </div>
 </template>  
 
  <script setup>
import CountryView from '@/components/CountryView.vue';
import FooterView from '@/components/FooterView.vue';
 import { ref } from 'vue';


const formData = ref({
  YourName: '',
  YourEmail: '',
  YourComment: ''
});
 

const handleSubmit = () => {
  console.log('Form Submitted:', formData.value);
  alert('Message sent successfully!');
  

  formData.value = {
    YourName: '',
    YourEmail: '',
    YourComment: ''
  };
};    
 </script>

 
 <style scoped>
.blogbeep{
  padding: 50px 0;
  text-align: center;
  width:100%; 
  margin: 0 auto;
 
}

.forbes{
font-family: Montserrat;
font-size: 55px;
font-style: normal;
font-weight: 900;
line-height: 136%; 
color: #000;
margin: 10px;
}

.sabi{
 color: #424242;
font-family: Montserrat;
font-size: 19px;
font-style: normal;
font-weight: 400;
line-height: 1.492;    
}

.virg{
  display:inline-flex;
  align-items: center;
  text-align: center; 
  justify-content: center;
  font-family: Montserrat;
font-size: 24px;
font-style: normal;
font-weight: 600;
line-height: 120%;
margin: 30px;
}

.stroll{
    text-align: justify;
    margin-right: 100px;
}

.face{
  text-align: center;
  justify-content: center;
  align-items: center;
   font-family: Montserrat;
font-size: 19px;
font-style: normal;
text-align: justify;
padding-top: 0;
margin-top: 0;
}

.face-jolie{
  border: none;
}

.face-jolie a{
text-decoration: none;
font-family: Montserrat;
font-size: 19px;
font-style: normal;
font-weight: bold;

color: #000;
}

.face-jolie a:hover{
  color: #761D9F;
}


.lucky{
  border: none;
 display: flex;
}

.lucky a{
text-decoration: none;
font-family: Montserrat;
font-size: 13px;
font-style: normal;
font-weight: bold;
line-height: 120%;
margin-left: 20px;
margin-top: 30px;
color: #761D9F;
}

.lucky a:hover{
  color: #000;
}

.blogbeep1{
 padding: 50px 0;
  text-align: center;
  width:100%; 
  margin: 0 auto;
  
}

.virg1{
    padding-bottom: 0;
margin-bottom: 0;
    margin-top: 0;
padding-top: 0;
  display:inline-flex;
  align-items: center;
  text-align: center; 
  justify-content: center;
  font-family: Montserrat;
font-size: 24px;
font-style: normal;
font-weight: 600;
line-height: 120%;
margin: 10px;
}

.seman{
width: 250px;
height: 150px;
border-radius: 15px;
background-color: #FFFFFF;
box-shadow: 20px 20px 20px 20px rgba(0, 0, 0, 0.2);
text-align: justify;
color: #000;
justify-content: center;
align-items: center;
display: center;
margin-top: 0;
padding-top: 0;
padding-bottom: 0;
margin-right: 100px;
margin-bottom: 4100px;
}

 .mother-pip115{ 
  text-align: justify;
  align-items: center;
        } 

 .mother-pip115 a{
    color: #000;
 
     margin-left: 30px;
 }    
 
 .prisma{
  align-items: center;
  max-width: 100%; 
  margin:0 auto;
  padding: 0 20px;
  text-align: justify;
  justify-content: center;
  margin-left: auto;
  margin-right: auto; 
  color: #000;
font-family: Montserrat;
font-size: 20px;
font-style: normal;
font-weight: 500;
line-height: 120% ;
 }

 .trima{
color: #424242;
font-family: Montserrat;
font-size: 19px;
font-style: normal;
font-weight: 400;
line-height: 1.492; 
text-align: justify;
 }

 .cough{
    margin-left: 70px;
 }

 .blogbeep2{
 padding: 50px 0;
  text-align: center;
  width:100%; 
  margin: 0 auto;
   background-color: #f8f8f8;
}

.virg2{
    padding-bottom: 0;
margin-bottom: 0;
    margin-top: 0;
padding-top: 0;
  display:inline-flex;
  align-items: center;
  text-align: center; 
  justify-content: center;
  font-family: Montserrat;
font-size: 24px;
font-style: normal;
font-weight: 600;
line-height: 120%;
 height: 250px;
 width: 96%;
   background-color: #f8f8f8;
 box-shadow: 20px 20px 20px 20px rgba(0, 0, 0, 0.2);
 border-radius: 15px;
 margin: 20px;
}

.skinny{
text-align: justify;
color: #000;
justify-content: center;
align-items: center;
display: center; 
 display: inline-flex;
 margin-right: 240px;
}

.skinny1{
 text-align: justify;
color: #000;
justify-content: center;
align-items: center;
display: center; 
 display: inline-flex;
}

.post{
 color: #424242;
font-family: Montserrat;
font-size: 19px;
font-style: normal;
font-weight: 400;
line-height: 1.492; 
text-align: justify; 
margin-left: 20px;
}

.post1{
 color: #424242;
font-family: Montserrat;
font-size: 19px;
font-style: normal;
font-weight: 400;
line-height: 1.492; 
text-align: justify; 
margin-left: 20px;
}

.lucky1{
  border: none;
 display: flex;
 text-align: justify;
}

.lucky1 a{
text-decoration: none;
font-family: Montserrat;
font-size: 20px;
font-style: normal;
font-weight: bold;
line-height: 1.2;
margin-left: 17px;
margin-top: 10px;
color: #000;
gap: 5px;
text-align: justify;
}

.lucky1 a:hover{
  color: #761D9F;
}


.lucky2{
  border: none;
 display: flex;
 text-align: justify;
}

.lucky2 a{
text-decoration: none;
font-family: Montserrat;
font-size: 20px;
font-style: normal;
font-weight: bold;
line-height: 1.2;
margin-left: 17px;
margin-top: 10px;
color: #000;
gap: 5px;
text-align: justify;
margin-right: 50px;
}

.lucky2 a:hover{
  color: #761D9F;
}


.blogbeep3{
 padding: 50px 0;
  text-align: center;
  width:100%; 
  margin: 0 auto;
  background-color: #FEFEFE;
}

.virg3{
    padding-bottom: 0;
margin-bottom: 0;
    margin-top: 0;
padding-top: 0;
  align-items: center;
  text-align: center; 
  justify-content: center;
  font-family: Montserrat;
font-size: 24px;
font-style: normal;
font-weight: 600;
line-height: 120%;
margin: 10px;
background-color: #FEFEFE;
}

.question{
  display: center;
  text-align: center;
  justify-content: center;
   color: black;
   font-size: 55px;
   font-weight: 750;
   margin-bottom: 0;
   padding-bottom: 0;
   margin-top: 150px;
}

.bloggers1{
  text-align: center;
  width:100%; 
  margin: 0 auto;
  color: #000;
   background-color: #f8f8f8;
   font-family: Montserrat;
font-size: 20px;
font-style: normal;
font-weight: 400;
line-height: 120%; 
margin-top: 60px;
}

.jmartins{
  display: inline-flex;
  font-size: 20px;
  text-align: center;
  justify-content: center;
  align-items: center;
  background-color: #f8f8f8;
   color: #000;
}

.studies{
  background-color: #FFFFFF;
  color: #000;
  height: 560px;
  width: 350px;
  margin: 15px;
  border-radius: 15px;
}

.villa{
  margin-top: 35px;
  border-radius: 15px;
}

.lucky7{
  border: none;
 display: flex;
}

.lucky7 a{
text-decoration: none;
font-family: Montserrat;
font-size: 13px;
font-style: normal;
font-weight: bold;
line-height: 120%;
margin-left: 20px;
margin-top: 30px;
color: #761D9F;
}

.lucky7 a:hover{
  color: #000;
}

.lucky9{
  border: none;
 display: flex;
 text-align: justify;
}

.lucky9 a{
text-decoration: none;
font-family: Montserrat;
font-size: 22px;
font-style: normal;
font-weight: bold;
line-height: 1.2;
margin-left: 17px;
margin-top: 10px;
color: #000;
gap: 5px;
}

.lucky9 a:hover{
  color: #761D9F;
}


.lucky2{
  border: none;
 display: flex;
 text-align: justify;
}

.lucky2 a{
text-decoration: none;
font-family: Montserrat;
font-size: 21px;
font-style: normal;
font-weight: bold;
line-height: 1.2;
margin-left: 17px;
color: #000;
gap: 5px;
}

.lucky2 a:hover{
  color: #761D9F;
}

.sabath{
 font-family: Montserrat;
font-size: 18px;
font-style: normal;
line-height: 1.2;
margin-left: 17px;
margin-top: 10px; 
text-align: justify;
}

.sabath2{
  margin-top: 0;
   font-family: Montserrat;
font-size: 18px;
font-style: normal;
line-height: 1.2;
margin-left: 17px; 
text-align: justify;
}

.sabath1{
 font-family: Montserrat;
font-size: 17px;
font-style: normal;
line-height: 1.1;
margin-left: 17px;
margin-top: 5px;
padding-top: 0; 
text-align: justify;
}

.face{
  display: inline-flex;
  text-align: center;
  justify-content: center;
  align-items: center;
   font-family: Montserrat;
font-size: 19px;
font-style: normal;
line-height: 1.1;
text-align: justify;
padding-top: 0;
margin-top: 0;

}

.face-jolie{
  border: none;
 display: flex;
}

.face-jolie a{
text-decoration: none;
font-family: Montserrat;
font-size: 19px;
font-style: normal;
font-weight: bold;
line-height: 120%;
color: #000;
}

.face-jolie a:hover{
  color: #761D9F;
}

.face-son{
  margin-right: 25px;
}

.face-cuzo{
  margin-right: 10px;
}

.face-cuzo1{
  margin-right: 56px;
}

.pius{
  display: inline-flex;
  text-align: center;
  justify-content: center;
  align-items: center;
   font-family: Montserrat;
font-size: 19px;
font-style: normal;
line-height: 1.1;
text-align: justify;
padding-top: 0;
margin-top: 0;
margin-bottom: 100px;
}

.pius-son{
  margin-right: 25px;
}

.pius-cuzo{
  margin-right: 10px;
}

.pius-cuzo1{
  padding-bottom:27px;
  margin-right: 56px;
}

.pius2{
  display: inline-flex;
  text-align: center;
  justify-content: center;
  align-items: center;
   font-family: Montserrat;
font-size: 19px;
font-style: normal;
line-height: 1.1;
text-align: justify;
margin-bottom: 100px;
}

.pius-son2{
  
  margin-right: 25px;
}

.pius-cuzo2{ 
  margin-right: 10px;
 
}

.pius-cuzo3{
 margin-bottom: 28px;
 margin-right: 50px;
}

.blogbeep4{
 padding: 50px 0;
  text-align: center;
  width:100%; 
  margin: 0 auto;
  background-color: #FEFEFE;
}

.virg4{
    padding-bottom: 0;
margin-bottom: 0;
    margin-top: 50px;
padding-top: 0;
  align-items: center;
  text-align: center; 
  justify-content: center;
  font-family: Montserrat;
font-size: 24px;
font-style: normal;
font-weight: 600;
line-height: 120%;
}

.solod{
font-family: Montserrat;
font-size: 20px;
font-style: normal;
font-weight: 400;
line-height: 120%; 
color: #424242;
margin-top: 70px;
}

.solod1{
font-family: Montserrat;
font-size: 20px;
font-style: normal;
font-weight: 400;
line-height: 120%; 
color: #424242;
margin-right: 160px;
}

 .contact-container {
    max-width: 800px;
  margin:100px auto;
  font-family: Arial, sans-serif;
 margin-left: 380px;
}

.contact-form {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.form-row {
  display: flex;
  gap: 20px;
}

.form-group {
  display: flex;
  flex-direction: column;
  flex: 1;
}

label {
  text-align: justify;
  font-size: 1.1rem;
  margin-bottom: 8px;
  color: #333;
  font-weight: 500;
}

input, select, textarea {
  padding: 15px;
  border-radius: 12px;
  border: 1px solid #ccc;
  background-color: #F4F4F4;
  font-size: 1rem;
  outline: none;
  transition: border-color 0.3s;
}

input:focus, select:focus, textarea:focus {
  border-color: #7b4397;
}

.button-container {
  display: flex;
  justify-content: flex-start;
}

.submit-btn {
  background: linear-gradient(270deg,
  var(--Purple-400, #A34FD3) 0%, var(--Purple-500, #8C1BC1) 100%), var(--Purple-400, #A34FD3);
  color: white;
  padding: 12px 30px;
  border: none;
  border-radius: 8px;
  font-weight: bold;
  cursor: pointer;
  letter-spacing: 1px;
  transition: opacity 0.3s;
  margin-left: 300px;
}

.submit-btn:hover {
  opacity: 0.9;
}

@media (max-width: 600px) {
  .form-row {
    flex-direction: column;
  }
}

.red{
  color: red;
}





@media screen and (max-width: 1024px) {
  .forbes {
    font-size: 40px !important;
    text-align: center !important;
  }

  .virg, .virg1, .virg2, .jmartins {
    flex-direction: column !important;
    width: 100% !important;
    margin: 0 !important;
    padding: 20px;
  }

  .stroll, .seman, .skinny, .skinny1 {
    margin-right: 0 !important;
    text-align: center !important;
    width: 100% !important;
  }

  .posture img {
    width: 100% !important;
    height: auto !important;
    max-width: 500px;
  }

  .seman {
    margin-bottom: 30px !important; 
    height: auto !important;
    box-shadow: 0 4px 10px rgba(0,0,0,0.1) !important;
  }

  .studies {
    width: 45% !important; 
    display: inline-block;
    vertical-align: top;
  }
  
  .contact-container {
    margin-left: 0 !important;
    max-width: 90%;
  }
}


@media screen and (max-width: 1024px) {
  .forbes {
    font-size: 38px !important; 
    text-align: center !important;
    line-height: 1.2 !important;
    br { display: none; } 
  }

  .virg {
    flex-direction: column !important; 
    margin: 20px auto !important;
    width: 95% !important;
  }

  .stroll {
    margin-right: 0 !important; 
    text-align: center !important;
    width: 100% !important;
  }

  .posture img {
    width: 100% !important;
    height: auto !important;
    max-width: 500px; 
    margin-top: 20px;
  }


  .virg1 {
    flex-direction: column !important;
    margin: 20px auto !important;
  }

  .seman {
    margin-right: 0 !important; 
    margin-bottom: 40px !important; 
    width: 100% !important;
    height: auto !important;
    max-width: 300px;
    box-shadow: 0 4px 10px rgba(0,0,0,0.1) !important;
  }

  .cough {
    margin-left: 0 !important;
    text-align: center;
  }


  .prisma {
    width: 100% !important;
    padding: 0 20px !important;
    text-align: justify;
  }

  .trima br {
    display: none; 
  }


  .virg2 {
    flex-direction: column !important;
    height: auto !important;
    padding: 20px 0 !important;
  }

  .skinny, .skinny1 {
    margin-right: 0 !important;
    width: 100% !important;
    justify-content: center !important;
    margin-bottom: 20px;
  }


  .jmartins {
    flex-wrap: wrap !important; 
    justify-content: center !important;
    width: 100% !important;
  }

  .studies {
    width: 45% !important; 
    margin: 10px !important;
    height: auto !important;
    padding-bottom: 20px;
  }

  .question {
    font-size: 32px !important;
    margin-top: 50px !important;
  }


  .contact-container {
    margin: 20px auto !important;
    margin-left: 30px !important;
    width: 90% !important;
  }

  .submit-btn {
    margin-left: 0 !important;
    width: 100% !important;
  }

  .solod1 {
    margin-right: 0 !important;
    text-align: center;
  }
}

@media screen and (max-width: 1024px) {
  .seman {
    height: auto !important;      
    margin-bottom: 40px !important; 
    margin-right: 0 !important;   
    width: 100% !important;
    max-width: 320px;             
    display: flex !important;
    flex-direction: column !important;
    align-items: center !important;
    padding: 20px !important;
  }


  .mother-pip115 {
    display: flex !important;
    flex-direction: row !important;
    justify-content: center !important;
    width: 100% !important;
    margin-top: 10px !important;
  }

  .mother-pip115 a {
    margin: 0 15px !important;     
    display: inline-block !important;
  }

  .icon-fb {
    font-size: 24px !important; 
    color: #000000 !important;      
    visibility: visible !important;
  }
}

@media screen and (max-width: 1024px) {
  .dube {
    display: flex !important;
    justify-content: center !important; 
    width: 100% !important;
    margin-bottom: 10px !important;
  }


  .lucky {
    list-style: none !important; 
    display: flex !important;
    justify-content: center !important;
    width: auto !important;
    padding: 0 !important;
  }

  .lucky a {
    margin-left: 0 !important; 
    margin-top: 0 !important; 
    text-align: center !important;
    display: inline-block !important;
    padding: 5px 10px !important; 
    font-size: 14px !important;    
  }
}






@media screen and (max-width: 430px) {
  .blogbeep, .blogbeep1, .blogbeep2, .blogbeep3, .blogbeep4 {
    padding: 20px 0 !important;
  }


  .forbes {
    font-size: 26px !important;
    line-height: 1.2 !important;
    br { display: none; }
  }

  .sabi, .trima {
    font-size: 16px !important;
    text-align: left !important;
    br { display: none; } 
  }

  .posture img {
    width: 90% !important;
    height: auto !important;
  }


  .seman {
    width: 90% !important;
    margin: 0 auto 2rem auto !important;
    height: auto !important;
    padding: 15px 0 !important;
  }
  
  .cough { margin-left: 0 !important; text-align: center; }
  .mother-pip115 { display: flex; justify-content: center; }
  .mother-pip115 a { margin: 0 10px !important; }

 
  .virg2 {
    flex-direction: column !important;
    height: auto !important;
    padding: 20px 0 !important;
  }

  .skinny, .skinny1 {
    margin: 10px 0 !important;
    width: 100% !important;
    flex-direction: column !important;
  }
  
  .skinny img, .skinny1 img {
    width: 120px !important;
    height: 120px !important;
  }

  
  .jmartins {
    display: flex !important;
    flex-direction: column !important;
    align-items: center !important;
  }

  .studies {
    width: 90vw !important;
    height: auto !important;
    padding-bottom: 20px;
  }

  .question {
    font-size: 28px !important;
    margin-top: 40px !important;
  }

 
  .contact-container {
    margin: 20px auto !important;
    padding: 0 15px !important;
    width: 100% !important;
  }

  .form-row {
    flex-direction: column !important;
    gap: 15px !important;
  }

  .solod1 {
    margin-right: 0 !important;
    font-size: 14px !important;
    text-align: center;
  }

  .submit-btn {
    margin-left: 0 !important;
    width: 100% !important;
  }
}
</style>